

































import {Component, Vue} from 'vue-property-decorator';

import {AuthStore} from '@/store/modules/auth.store';
import {LocationStore} from '@/store/modules/location.store';
import {BadgeStore} from '@/store/modules/badge.store';
// @ is an alias to /src

@Component({
	components: {

	}
})
export default class Drawer extends Vue {
	close() {
		this.$emit('close');
	}

	get location() {
		return LocationStore.location;
	}

	activeClass(name: string) {
		return this.$route.name === name ? 'active' : '';
	}

	async logout() {
		if(await this.$bvModal.msgBoxConfirm('Are you sure you want to logout?', {
			centered: true,
			cancelTitle: 'Cancel',
			okTitle: 'Logout',
			okVariant: 'danger'
		})) {
			AuthStore.clearAuthCredentials();
		}
	}

	navigate(path: string) {
		this.$router.push(path);
		this.close();
	}
}
